import _ from 'lodash';
import { routeCreator } from '@adrias-online/steiner/lib/helpers';

// import helper from '../../../helpers/steinerHelper';
import routeRegister from '../../../helpers/routeRegister';
import { selectors } from '../reducers/portaliGalleries';
import { generateRoutes } from '../../../helpers/portaleModuleHelper';

const routes = generateRoutes('gallerie', selectors);
// const routes = helper.generateRoutes('portaliGalleries', selectors);

routes.list.list.breadcrumb = 'Gallery & Foto';

const list = _.values(routes.list).map(route => ({
    ...route,
    requiredRoles: ['admin', 'developer', 'employee', 'amministrazione'],
    getComponent() {
        return new Promise(resolve => {
            import(/* webpackChunkName: 'portaliGalleries' */ `modules/portaliGalleries/${
                route.componentPath
            }`).then(response => resolve(response.default));
        });
    }
}));

const links = routeCreator.generateLinks(routes.patterns);

routeRegister.addPatterns('portaliGalleries', routes.patterns);
routeRegister.addLinks('portaliGalleries', links);

export default list;
